import { anyPass, equals } from 'ramda';
import { InputType } from '../types/input.types';

export const isSelectableField = anyPass([equals(InputType.CHOICE), equals(InputType.SELECT)]);
